import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IframeCommunicationService {
    private messageSubject = new Subject<MessageEvent>();
    private isListenerActive = false;
    
    constructor(private ngZone: NgZone) {
        console.log('IframeCommunicationService');
        this.setupListener();
    }
    
    // Desde la ventana padre al iframe
    public sendToIframe(iframe: HTMLIFrameElement, message: any): void {
        // Usamos el origen del iframe dinámicamente
        const targetOrigin = iframe.src.startsWith('http') ? 
        new URL(iframe.src).origin : 
        window.origin;
        
        iframe.contentWindow?.postMessage(message, targetOrigin);
    }
    
    // Desde el iframe a la ventana padre
    public sendToParent(message: any): void {
        // Usamos document.referrer para obtener el origen padre
        const parentOrigin = document.referrer ? 
        new URL(document.referrer).origin : 
        window.origin;
        
        window.parent.postMessage(message, parentOrigin);
    }
    
    private setupListener(): void {
        if (this.isListenerActive) return;
        
        window.addEventListener('message', (event) => {
            this.ngZone.run(() => {
                this.messageSubject.next(event);
            });
        });
        
        this.isListenerActive = true;
    }
    
    public get messages$(): Observable<MessageEvent> {
        return this.messageSubject.asObservable();
    }
}